(ns ui.constants
  (:require
   [clojure.string :as string]))

(defonce MAX-SAFE-INTEGER (.-MAX_SAFE_INTEGER js/Number))
(defonce MIN-SAFE-INTEGER (.-MIN_SAFE_INTEGER js/Number))

(defonce MAX_INTEGER_CHAR_LENGTH (max (count (str MAX-SAFE-INTEGER))
                                      (count (str MIN-SAFE-INTEGER))))

(defonce MAX-NUMBER-VALUE (.-MAX_VALUE js/Number))

(defonce thousand-separator
         (let [separator (->> "1000"
                              (js/Number.)
                              (.toLocaleString)
                              (second)) ;; thousand separator is the 2nd if not digit
               th-separator (if-not (js/isNaN separator)
                              ""
                              (str separator))]
           (string/trim th-separator)))

(defonce decimal-separator
         (let [separator (->> "1.1"
                              (js/Number.)
                              (.toLocaleString)
                              (second))] ;; thousand separator is the 2nd - always
           (string/trim (str separator))))
